// extracted by mini-css-extract-plugin
export default {"image":"Gallery_image__L74ey"};